import Image from "next/image";
import Link from "next/link";

const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-end lg:items-center overflow-hidden mt-[30px]">
      <div className="absolute inset-0">
        <Image
          src="/assets/hero-bg.webp"
          alt="Kasai Equipment heavy machinery operating on a rugged jobsite"
          fill
          priority
          sizes="100vw"
          className="object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground/90 via-foreground/60 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[100vw] md:max-w-[1440px] px-4 pt-28 pb-6 sm:pb-8 lg:pt-24">
        <div className="w-full max-w-[22rem] sm:max-w-4xl min-w-0">
          <div>
            <span className="inline-block bg-secondary text-secondary-foreground px-4 py-1.5 rounded-full text-[11px] sm:text-xs font-bold tracking-widest uppercase mb-6">
              Exclusive Dealer of Engirise
            </span>
          </div>

          <h1
            className="font-bold text-4xl sm:text-6xl md:text-8xl lg:text-8xl leading-none tracking-tight text-card mb-6 break-words"
          >
            Powering Process with
            <br />
            <span className="text-secondary">
              Reliable Machinery
            </span>
          </h1>

          <p
            className="text-base sm:text-lg md:text-xl text-card/70 max-w-xl mb-8 sm:mb-10 font-light leading-relaxed break-words"
          >
            Your trusted equipment partner in DR Congo. Excavators, Loaders, Forklifts and more – delivered, supported and serviced locally.
          </p>

          <div
            className="flex flex-col sm:flex-row flex-wrap gap-4"
          >
            <Link
              href="/products"
              className="bg-primary text-primary-foreground px-8 py-4 rounded-lg font-bold text-base hover:glow-primary transition-all duration-300 hover:-translate-y-1 w-full sm:w-fit text-center"
            >
              Explore Equipment
            </Link>
            <Link
              href="/contact"
              className="group text-secondary px-8 py-4 rounded-lg font-bold text-base transition-all duration-300 hover:-translate-y-1 ring-1 border border-secondary w-full sm:w-fit text-center hover:glow-secondary"
            >
              Request Quote
            </Link>
          </div>
        </div>

        <div
          className="my-6 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 w-full max-w-[22rem] sm:max-w-3xl min-w-0"
        >
          {[
            { value: "8+", label: "Equipment Categories" },
            { value: "24/7", label: "Technical Support" },
            { value: "10+", label: "Expert Technicians" }
          ].map((stat) => (
            <div key={stat.label} className="glass-dark rounded-xl p-4 text-center">
              <div className="font-display text-2xl sm:text-3xl md:text-4xl text-secondary">{stat.value}</div>
              <div className="text-xs text-card/60 mt-1 font-medium tracking-wide uppercase">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
